angular.module('zc.zenclerkS')
  .controller('ZcsSiteTagsController', ZcsSiteTagsController);

ZcsSiteTagsController.$inject = ['$rootScope', '$scope', 'Project', 'project'];
function ZcsSiteTagsController($rootScope, $scope, Project, project) {
  let vm = this;

  // variables
  vm.project = project;
  vm.currentState = 'tracking';

  // actions

  activate();

  function activate() {
    $scope.$on('trackingTagFound', params => {
      if(!vm.project.tracking_tag_confirmed_at) {
        vm.project.tracking_tag_confirmed = true;
        updateProject();
      }
    });

    $scope.$on('conversionTagFound', params => {
      if(!vm.project.conversion_tag_confirmed_at) {
        vm.project.conversion_tag_confirmed = true;
        updateProject();
      }
    });
  }

  function updateProject() {
    Project.update({ projectId: `apikey:${vm.project.apikey}` }, { project: vm.project })
      .then(newProject => {
        vm.project = newProject;
        $rootScope.$emit('projectUpdated', vm.project);
      });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/tags/site_tags.controller.js